<template>
    <!-- Новий дизайн: «Питання й відповіді» — ті самі, що в статичних сторінках для ботів і в JSON-LD (seo/content.js).
         Відповіді з цифрами (пороги доставки, вага, ціни) збірка рахує з API й кладе в seo/faq.json; немає файлу — блоку немає -->
    <section v-if="items.length" class="bp-faq" :class="'bp-faq--' + variant" :aria-labelledby="headId">
        <h2 :id="headId" :class="variant == 'about' ? 'bp-ab-h2' : 'bp-menu-sec__title'">Питання й відповіді</h2>
        <div class="bp-faq__list">
            <details v-for="item in items" :key="item.q" class="bp-faq__item">
                <summary class="bp-faq__q"><span>{{ item.q }}</span><span class="bp-faq__chev" v-html="chevron"></span></summary>
                <p class="bp-faq__a">{{ item.a }}</p>
            </details>
        </div>
    </section>
</template>

<script>
import { ICONS } from '@/v2icons'

// Один запит на сесію, хоч блок стоїть і під меню, і в «Про нас»
let loading = null;
function loadFaq() {
    if (!loading) {
        loading = fetch(process.env.BASE_URL + 'seo/faq.json')
            .then(response => response.ok ? response.json() : [])
            .then(items => Array.isArray(items) ? items.filter(item => item && item.q && item.a) : [])
            .catch(() => []);
    }
    return loading;
}

export default {
    name: 'BpFaq',
    props: { variant: { type: String, default: 'menu' } },
    data() {
        return { items: [], chevron: ICONS.chevronRight };
    },
    computed: {
        headId() { return 'bp-faq-h-' + this._uid; }
    },
    created() {
        loadFaq().then(items => { this.items = items; });
    }
}
</script>
